import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { CompanySelectObject } from "app/pages/sales-intelligence/modules/leads-search-filters/types/description.dto";

export default class CompanyFilter extends FilterPanelBaseFilter<readonly string[], readonly CompanySelectObject[]> {
    constructor(deps: IFilterPanelBaseFilterDeps<readonly string[], readonly CompanySelectObject[]>) {
        super(deps);
    }
}
